var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.show,"no-wrap":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }